import { getFlowSteps } from '../flow-initial/getFlowConfig';
import { FlowManager } from '../flow-management/FlowManager';
import { setFlow } from '../store/flow/action-creators';
import { Step } from '../views/Step';
export const setFlowAfterGoogleCredentialAuthentication = () => dispatch => {
  const preVerificationSteps = FlowManager.removeSteps(Step.LandingPage, Step.Name, Step.CodeVerification, Step.Verification)(getFlowSteps().preVerification);
  const postVerificationSteps = FlowManager.removeSteps(Step.Password)(getFlowSteps().postVerification);
  const postAccountCreationSteps = getFlowSteps().postAccountCreation;
  const postExistingAccountSelectionSteps = getFlowSteps().postAccountCreation;
  const nextSteps = [...preVerificationSteps, ...postVerificationSteps, ...postAccountCreationSteps];
  dispatch(setFlow(nextSteps, preVerificationSteps, postVerificationSteps, postAccountCreationSteps, postExistingAccountSelectionSteps));
};